import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import BusinessIntegration from '../MenserviceBusinessIntegration/BusinessIntegration'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Business Integration Strategy" />
                <BusinessIntegration />
                <Footer />
            </div>
        </>
    )
}

export default Main